import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
}

.color {
  height: 100%;
}

.content {
  padding-top: 1rem;
}

/**
--------------------------------------------------
* Display
--------------------------------------------------
*/

.layout-default .display-color {
  aspect-ratio: 16/9;
  border-radius: var(--p-color-boxed-border-radius, 5px);
}

.layout-square .display-color {
  aspect-ratio: 1/1;
  border-radius: var(--p-color-boxed-border-radius, 5px);
}

.boxed .display-color{
  border-radius: var(--p-color-boxed-border-radius, 5px) var(--p-color-boxed-border-radius, 5px) 0 0;
}

.layout-circle .display-color {
  aspect-ratio: 1/1;
  border-radius: 50%;
}

.layout-circle.boxed .display {
  padding: 1rem 1rem 0 1rem;
}

/**
--------------------------------------------------
* Values
--------------------------------------------------
*/
.values {
  display: grid;
  column-gap: .1rem;
  grid-template-columns: 30% 70%;
  font-size: .875rem;
}

.label {
  font-weight: bold;
}

button.value {
  border: none;
  background: none;
  appearance: none;
  color: var(--p-color-text);
  cursor: pointer;
  font-size: inherit;
  font-weight: inherit;
  padding: .25rem .5em;
  text-align: left;
  border-radius: 5px;
}

button.value:hover {
  background: var(--p-text-color-contrast-100);
}

button.value.success {
  color: var(--p-success);
  pointer-events: none;
}


/**
--------------------------------------------------
* Boxed
--------------------------------------------------
*/
.boxed{
  border: 1px solid var(--p-border);
  background-color: var(--p-boxed-bg);
  border-radius: var(--p-color-boxed-border-radius, 5px);
  overflow: hidden;
}

.boxed .content {
  padding: var(--p-color-boxed-padding, 1rem);
}

`;
